module.exports = __webpack_public_path__ + "static/media/Madfit_Website_06.c0f2033c.jpg";